import { PIN } from '../config/pin';
import { mulberry32 } from '../utils/prng';

export class PinChallenge {
  readonly code: string;
  private entered = '';
  private mistakes = 0;
  private unlocked = false;

  constructor(readonly seed: number = 0) {
    const random = mulberry32(seed);
    this.code = Array.from({ length: PIN.length }, () => Math.floor(random() * 10)).join('');
  }

  get input(): string { return this.entered; }
  get errors(): number { return this.mistakes; }
  get complete(): boolean { return this.unlocked; }

  /** 0..9 are digits, 10 is backspace; all other inputs are inert. */
  press(key: number): void {
    if (this.unlocked) return;
    if (key === 10) {
      this.entered = this.entered.slice(0, -1);
      return;
    }
    if (!Number.isInteger(key) || key < 0 || key > 9) return;
    this.entered += key;
    if (this.entered.length !== PIN.length) return;
    if (this.entered === this.code) this.unlocked = true;
    else {
      this.mistakes++;
      this.entered = '';
    }
  }
}
